import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';

import { BaseComponent } from '@shared/components/base-component';

@Component({
  selector: 'dsm-search-input',
  templateUrl: './search-input.component.html',
})
export class SearchInputComponent extends BaseComponent implements OnInit, OnDestroy {

  @Input() label?: string;
  @Output() searchChanged = new EventEmitter<string>();

  searchCtrl = new FormControl('');

  form = this.formBuilder.group({
    search: this.searchCtrl,
  });

  constructor(
    private formBuilder: FormBuilder
  ) {
    super();

    this.subToSearchValueChanges();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  private subToSearchValueChanges() {
    this.addToUnsubscribe(
      this.searchCtrl.valueChanges.subscribe(() => {
        if (this.searchCtrl.valid || this.searchCtrl.value?.length === 0)
          this.searchChanged.emit(this.searchCtrl.value ?? '');
      }));
  }

}
